var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUsTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.68,252.44c-90.43-52.21-236.58-52.21-326.43,0S-3.12,389.32,87.31,441.53s236.59,52.21,326.44,0S503.12,304.66,412.68,252.44Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.68,421.28c-16-9.23-41.84-9.23-57.73,0s-15.81,24.21.19,33.44,41.84,9.24,57.73,0S243.68,430.52,227.68,421.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,427.21c-15.95-9.2-41.71-9.2-57.55,0s-15.75,24.13.19,33.33,41.71,9.21,57.54,0S341.05,436.42,325.11,427.21Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,353.31c-14-8.08-36.61-8.08-50.51,0s-13.83,21.18.16,29.25,36.61,8.08,50.51,0S413.11,361.39,399.12,353.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,297.26c-14.89-8.6-38.95-8.6-53.74,0s-14.72,22.53.17,31.13,38.95,8.6,53.74,0S362,305.86,347.11,297.26Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,221.72c0-2.56-.91-4.37-2.36-5.24h0l0,0-.06,0h0l-8.61-5h0a3,3,0,0,0-.59-.31,4.18,4.18,0,0,0-1.34-.32,4.87,4.87,0,0,0-.85,0l-.28,0-.63.12-.32.09a5.9,5.9,0,0,0-.67.23l-.3.12a8.47,8.47,0,0,0-1,.5L73.92,343.58h0a9.4,9.4,0,0,0-.88.57l-.28.2-.59.46h0l-.3.26h0l-.54.49h0l-.29.29-.51.55-.27.29-.5.61c-.08.1-.15.2-.23.29h0c-.17.23-.34.46-.5.7l-.18.26c-.18.26-.35.53-.52.81a1.74,1.74,0,0,0-.11.18,18.14,18.14,0,0,0-.89,1.69c0,.1-.09.19-.14.29l-.24.59h0c-.06.13-.11.25-.16.38s-.13.36-.2.55-.09.29-.14.43h0a4.91,4.91,0,0,0-.15.51h0l-.12.49h0L66,355h0c0,.18-.07.36-.1.54h0c0,.14-.06.28-.08.42h0c0,.2,0,.41-.07.61h0c0,.11,0,.23,0,.34h0c0,.31,0,.63,0,.93h0l.41,3.93a7.8,7.8,0,0,0,.59,3.15,4.94,4.94,0,0,0,.69,1.14,4.25,4.25,0,0,0,.91.84h0a3.42,3.42,0,0,0,.46.26l8.49,4.95h0l.13.07.06,0h0c1.48.78,3.49.63,5.71-.64l73.09-42.1,38,22.81c.49.28,1,.54,1.49.79l.5.24c.34.16.69.32,1,.46l.6.24c.32.13.65.25,1,.36l.64.22,1,.29.65.17c.33.09.66.16,1,.23l.62.13c.36.07.73.13,1.1.18l.53.08c.54.07,1.09.13,1.64.17s1.16.05,1.74.05,1.16,0,1.75-.05a27.05,27.05,0,0,0,3.46-.44c.66-.13,1.31-.29,1.95-.46l.6-.18c.46-.14.9-.28,1.35-.44l.66-.25c.44-.17.88-.35,1.31-.54l.59-.26c.61-.3,1.22-.61,1.82-.95l29.21-16.71A11,11,0,0,0,255.76,324a10.82,10.82,0,0,0-5.14-7.39l-16.7-10-7.09-4.25a9.46,9.46,0,0,1-1-.72,9.61,9.61,0,0,1-3.32-5.06,9.73,9.73,0,0,1-.32-2.47V291.5l89.65-51.63c4.54-2.62,8.22-9,8.2-14.21Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.3,325.92l-4.64-3.8c-.28-7.32-.57-15,.65-22.23s4.05-14.36,9.21-19.54c2.16-2.17,4.84-4,7.89-4.37s6.44,1.18,7.49,4.06-.56,6.29-2.32,9c-3.76,5.71-8.25,10.92-11.93,16.68A40.71,40.71,0,0,0,433.3,325.92Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.3,326.92l4.64,3.81c3.43-7.24,8.16-13.94,14.68-18.58a40.3,40.3,0,0,0,6.5-5c1.88-2,3.18-4.77,2.64-7.46-.7-3.44-4.36-5.72-7.88-5.74s-6.81,1.76-9.53,4C436,304.75,431.19,316.33,433.3,326.92Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.3,326.92l4.64,3.81c3.43-7.24,8.16-13.94,14.68-18.58a40.3,40.3,0,0,0,6.5-5c1.88-2,3.18-4.77,2.64-7.46-.7-3.44-4.36-5.72-7.88-5.74s-6.81,1.76-9.53,4C436,304.75,431.19,316.33,433.3,326.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.68,324.18h0a.42.42,0,0,1-.4-.41c.19-10.84,2.63-30.87,16.8-43.18a.4.4,0,0,1,.53.61c-6,5.2-16.09,17.64-16.52,42.58A.42.42,0,0,1,430.68,324.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.54,329.17h0a.4.4,0,0,1-.36-.44c.94-9.75,5.2-23.17,20.07-31.77a.4.4,0,0,1,.4.7c-14.58,8.42-18.75,21.59-19.68,31.14A.4.4,0,0,1,435.54,329.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,308.87c-2.71-2.28-5.72-4.21-8.28-6.66-1.74-1.67-3.35-3.82-3.23-6.23a6,6,0,0,1,3.88-5.05,9.2,9.2,0,0,1,6.57.16,19.94,19.94,0,0,1,5.64,3.59,48.14,48.14,0,0,1,16.59,31.78,7.24,7.24,0,0,1-.47,4.13,4,4,0,0,1-3.77,2c-3.86-.37-4.34-5.39-5.51-8.17a41.33,41.33,0,0,0-6.43-10.55A40.72,40.72,0,0,0,49.49,308.87Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1,328.65a.33.33,0,0,1-.31-.25c-1.41-5.8-7.25-25.41-23.25-34a.32.32,0,1,1,.31-.57c16.24,8.75,22.15,28.59,23.57,34.46a.32.32,0,0,1-.24.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,336.77a9.92,9.92,0,0,1-3.25,7.08,12.77,12.77,0,0,1-6.54,2.46,30.38,30.38,0,0,1-7.19-.27c-1.18-.16-2.51-.42-2.89-1.76a2.46,2.46,0,0,1,.4-2.08,8.18,8.18,0,0,1,.59-.76.72.72,0,0,0-.62-1.19,17,17,0,0,1-2,.14A8.81,8.81,0,0,1,44,339.34a7,7,0,0,1-2.45-2.44,2.7,2.7,0,0,1-.27-2.81,3.12,3.12,0,0,1,1.39-1c.47-.2.94-.39,1.42-.56a.67.67,0,0,0-.09-1.28l-2.25-.46a3.89,3.89,0,0,1-1.77-.67,3.47,3.47,0,0,1-1-2.78c0-1.35.2-2.69.25-4a8.47,8.47,0,0,0-.64-4,33.43,33.43,0,0,1,11.79-1.51,8.47,8.47,0,0,1,3.45.76,4.76,4.76,0,0,1,2.34,4,.3.3,0,0,0,.59.05l.85-2.71a1.6,1.6,0,0,1,1.93-1.06,9.67,9.67,0,0,1,3.51,1.79,5.36,5.36,0,0,1,2.06,3.62,35.26,35.26,0,0,1,.16,5.9.53.53,0,0,0,.93.39l.06,0a1.83,1.83,0,0,1,1.18-.62c1.2-.08,1.73,1.05,2,2.05A19.85,19.85,0,0,1,70,336.77Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,336.77a9.92,9.92,0,0,1-3.25,7.08,12.77,12.77,0,0,1-6.54,2.46,30.38,30.38,0,0,1-7.19-.27c-1.18-.16-2.51-.42-2.89-1.76a2.46,2.46,0,0,1,.4-2.08,8.18,8.18,0,0,1,.59-.76.72.72,0,0,0-.62-1.19,17,17,0,0,1-2,.14A8.81,8.81,0,0,1,44,339.34a7,7,0,0,1-2.45-2.44,2.7,2.7,0,0,1-.27-2.81,3.12,3.12,0,0,1,1.39-1c.47-.2.94-.39,1.42-.56a.67.67,0,0,0-.09-1.28l-2.25-.46a3.89,3.89,0,0,1-1.77-.67,3.47,3.47,0,0,1-1-2.78c0-1.35.2-2.69.25-4a8.47,8.47,0,0,0-.64-4,33.43,33.43,0,0,1,11.79-1.51,8.47,8.47,0,0,1,3.45.76,4.76,4.76,0,0,1,2.34,4,.3.3,0,0,0,.59.05l.85-2.71a1.6,1.6,0,0,1,1.93-1.06,9.67,9.67,0,0,1,3.51,1.79,5.36,5.36,0,0,1,2.06,3.62,35.26,35.26,0,0,1,.16,5.9.53.53,0,0,0,.93.39l.06,0a1.83,1.83,0,0,1,1.18-.62c1.2-.08,1.73,1.05,2,2.05A19.85,19.85,0,0,1,70,336.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,343.86a47.81,47.81,0,0,0-4.91-8.45.36.36,0,0,0-.16-.22c-.1-.14-.21-.28-.31-.43a29.94,29.94,0,0,1,1-11,.32.32,0,1,0-.61-.21,30.07,30.07,0,0,0-1.16,10.25,43.3,43.3,0,0,0-16.56-13.43.33.33,0,0,0-.43.17.33.33,0,0,0,.17.43,43,43,0,0,1,16.81,13.89,20,20,0,0,0-11.38.68.33.33,0,0,0,.12.63l.12,0a19.26,19.26,0,0,1,11.78-.42,47.32,47.32,0,0,1,4.87,8.37.33.33,0,0,0,.3.2l.12,0A.33.33,0,0,0,65,343.86Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.11,56.34c4.2-2.43,7.76-1.24,8.89,2.53a12.5,12.5,0,0,1,4.54-5c3.3-1.91,6-.38,6,3.41V59L115,56.41c2.31-1.33,4.19-.26,4.2,2.4A9.19,9.19,0,0,1,115,66L77.5,87.67c-2.31,1.33-4.19.26-4.19-2.39a9.17,9.17,0,0,1,4.17-7.22L81.9,75.5V72.3C81.87,66.43,86,59.29,91.11,56.34Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85,70.52c3-1.74,5.57-.89,6.38,1.82a8.89,8.89,0,0,1,3.26-3.63c2.36-1.37,4.29-.27,4.3,2.45v1.25L145,70.57c1.66-1,3-.18,3,1.72a6.64,6.64,0,0,1-3,5.18L118.08,93c-1.66,1-3,.19-3-1.71a6.57,6.57,0,0,1,3-5.18l3.18-1.84V82A14.56,14.56,0,0,1,127.85,70.52Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.76,313.59a10.82,10.82,0,0,0-5.14-7.39l-23.79-14.27a9.62,9.62,0,0,1-4.67-8.26V272.34l-53.78,31.09L163.89,306v12.76h0a9.6,9.6,0,0,0,2.92,6.91c.26.25.54.49.83.72a8.63,8.63,0,0,0,1.07.71l25.55,14.73A26.94,26.94,0,0,0,206,345.4q.87.06,1.74.06c.58,0,1.16,0,1.75,0a26.92,26.92,0,0,0,11.74-3.52l29.21-16.72A10.94,10.94,0,0,0,255.76,313.59Z",
    style: {
      fill: "#455a64",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,313.59a10.82,10.82,0,0,0-5.14-7.39l-23.79-14.27a9.62,9.62,0,0,1-4.67-8.26V272.34l-53.78,31.09L163.89,306v12.76a9.61,9.61,0,0,0,4.82,8.34l25.55,14.73a27.09,27.09,0,0,0,27,0l29.21-16.72A10.94,10.94,0,0,0,255.76,313.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43,321.1l-29,16.59a27.51,27.51,0,0,1-27.38,0l-21.52-12.41a8.22,8.22,0,0,1-4.13-7.13l0-14.68L163.89,306v12.76a9.61,9.61,0,0,0,4.82,8.34l25.55,14.73a27.09,27.09,0,0,0,27,0l29.21-16.72a10.94,10.94,0,0,0,5.33-11.58A10.85,10.85,0,0,1,250.43,321.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.53,325.24a8.22,8.22,0,0,1-4.13-7.13l0-14.68L163.89,306v12.76a9.61,9.61,0,0,0,4.82,8.34l9.06,5.23v-4.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.53,325.24l5.24,3h0l56.15-32.09-7.09-4.25a9.62,9.62,0,0,1-4.67-8.26V272.34l-53.78,31.09,0,14.68A8.22,8.22,0,0,0,172.53,325.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,31.32c0-2.57-.91-4.38-2.36-5.25h0l0,0-.06,0h0l-8.61-5h0a3.63,3.63,0,0,0-.59-.3,4.18,4.18,0,0,0-1.34-.32,7.14,7.14,0,0,0-4.05,1.11L73.92,153.18h0c-.3.17-.59.36-.88.56l-.28.21-.59.46-.3.26-.54.49-.29.29-.51.54-.27.3c-.17.2-.34.4-.5.61l-.23.29c-.17.23-.34.46-.5.7l-.18.25c-.18.27-.35.54-.52.82a1.74,1.74,0,0,0-.11.18,18.14,18.14,0,0,0-.89,1.69l-.14.29-.24.59c-.06.12-.11.25-.16.38l-.2.54-.14.44c-.06.17-.11.34-.16.51l-.12.49-.12.47c0,.18-.07.36-.1.53s-.06.29-.08.42,0,.42-.07.62,0,.22,0,.34c0,.31,0,.62,0,.93h0l.41,183.94a7.8,7.8,0,0,0,.59,3.15,4.49,4.49,0,0,0,1.6,2h0a5,5,0,0,0,.46.26l8.49,4.95h0l.13.07.06,0h0c1.48.78,3.49.63,5.71-.65L311.81,229.47c4.54-2.62,8.22-9,8.2-14.21Zm-237,141.15A10,10,0,0,1,84.91,167a10,10,0,0,0-2.28,5.44Zm223-133.2h0l-218.9,126L311.49,35.91l-5.82,3.36Zm-223,134.46L83,345.64l0,6.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.47,361.79h0l-.06,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.24,26.07l0,0,0,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,31.32c0-2.57-.91-4.38-2.36-5.25l0,0-.06,0-8.61-5h0c-1.5-1-3.62-.87-6,.49L73.92,153.18c-4.55,2.63-8.22,9-8.2,14.21l.41,183.94c0,2.46.84,4.22,2.19,5.13h0a5,5,0,0,0,.46.26l8.49,4.95.13.07.06,0c1.48.78,3.49.63,5.71-.65L311.81,229.47c4.54-2.62,8.22-9,8.2-14.21ZM306.06,212.44a10.23,10.23,0,0,1-4.14,7.16L83,345.64l0,6.2-.4-179.37a10.19,10.19,0,0,1,4.14-7.15L311.49,35.91l-5.82,3.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,212.44l-.39-173.17-218.9,126a10.19,10.19,0,0,0-4.14,7.15L83,345.64l218.91-126A10.23,10.23,0,0,0,306.06,212.44Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,212.44l-.39-173.17-218.9,126a10.19,10.19,0,0,0-4.14,7.15L83,345.64l218.91-126A10.23,10.23,0,0,0,306.06,212.44Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,212.44l-.39-173.17-218.9,126a10.19,10.19,0,0,0-4.14,7.15L83,345.64l218.91-126A10.23,10.23,0,0,0,306.06,212.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.53,21h0c-1.5-1-3.62-.87-6,.49L73.92,153.18a17.29,17.29,0,0,0-6.29,7l8.8,5.08a17.21,17.21,0,0,1,6.28-7L311.34,26.62c2.26-1.31,4.31-1.44,5.8-.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,167.39l.41,183.94c0,2.46.84,4.22,2.19,5.13h0a5,5,0,0,0,.46.26l8.49,4.95c-1.46-.87-2.36-2.69-2.36-5.25L74.5,172.49a16.23,16.23,0,0,1,1.93-7.22l-8.8-5.08A16.12,16.12,0,0,0,65.72,167.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.49,35.91l-5.82,3.36.39,173.17a10.23,10.23,0,0,1-4.14,7.16L83,345.64l0,6.2L307.75,222.43a10.19,10.19,0,0,0,4.14-7.15Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "106.89 204.47 106.85 191.19 97.92 186.04 97.96 199.02 97.96 199.02 97.96 199.32 106.89 204.47 106.89 204.47",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.32,358.35l-.43-153.88L98,199.32l.43,153.58a2.89,2.89,0,0,0,1.17,2.6h0l0,0,0,0,8.83,5.38A2.93,2.93,0,0,1,107.32,358.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,360.69a4.37,4.37,0,0,1-.8.37A4.37,4.37,0,0,0,111.44,360.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.08,361.19l-.17,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.66,361.05v0h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,191.16l0-7.65a9,9,0,0,1,4.09-7.09L342.81,42.55a2.89,2.89,0,0,1,2.87-.3l-8.84-5.41h0a2.86,2.86,0,0,0-3,.25L102,171a9,9,0,0,0-4.09,7.1l0,7.65h0l0,0v.3l8.93,5.15Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,191.16l0-7.65a9,9,0,0,1,4.09-7.09L342.81,42.55a2.89,2.89,0,0,1,2.87-.3l-8.84-5.41h0a2.86,2.86,0,0,0-3,.25L102,171a9,9,0,0,0-4.09,7.1l0,7.65h0l0,0v.3l8.93,5.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.89 204.47 106.85 191.19 97.92 186.04 97.96 199.02 97.96 199.02 97.96 199.32 106.89 204.47 106.89 204.47",
    style: {
      fill: "#e0e0e0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.81,42.55c2.26-1.31,4.11-.25,4.11,2.35l0,7.66L106.87,191.16l0-7.65a9,9,0,0,1,4.09-7.09Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.26,55.21c1.22-.7,2.2-.14,2.21,1.26a4.85,4.85,0,0,1-2.19,3.79c-1.21.7-2.2.13-2.2-1.26A4.81,4.81,0,0,1,327.26,55.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,51.34c1.21-.7,2.2-.13,2.21,1.26A4.85,4.85,0,0,1,334,56.39c-1.22.7-2.2.14-2.21-1.26A4.85,4.85,0,0,1,334,51.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,47.48c1.22-.7,2.2-.14,2.21,1.26a4.85,4.85,0,0,1-2.19,3.79c-1.21.7-2.2.13-2.21-1.26A4.85,4.85,0,0,1,340.65,47.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.16,155.7c.9-.52,1.74-.44,2.17.23l2.18,3.36c.43.67,1.26.77,2.17.24L346.92,52.58l0,13.31L106.89,204.49l0-13.3,7.11-4.11a5.38,5.38,0,0,0,2.17-2.75l2.15-5.85a5.38,5.38,0,0,1,2.16-2.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,65.87l.43,153.87a9,9,0,0,1-4.09,7.09L111.44,360.69c-2.27,1.31-4.11.26-4.12-2.34l-.43-153.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.46,60.76c1.61-.93,2.92-.19,2.92,1.66a6.4,6.4,0,0,1-2.9,5L134.27,184.78c-1.62.94-2.93.19-2.93-1.66a6.39,6.39,0,0,1,2.91-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,192.37a.26.26,0,0,1,.3,0c.15.1.14.41,0,.68l-1.29,2.09,3.37-1.94c.23-.13.41,0,.41.23a.93.93,0,0,1-.41.72l-3.36,1.94,1.29.61c.16.08.18.37,0,.65a.85.85,0,0,1-.3.32.33.33,0,0,1-.28,0l-2.06-1-.09-.08v0l0-.16,0-.21v0l.08-.17,2-3.36A.89.89,0,0,1,110.73,192.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,188.17a.31.31,0,0,1,.29,0l2.06,1,.08.09h0l0,.17,0,.21,0,0-.07.16-2.06,3.38a.83.83,0,0,1-.28.28.3.3,0,0,1-.3,0c-.15-.1-.14-.4,0-.68L119,190.7l-3.36,1.94c-.23.13-.41,0-.41-.24a.91.91,0,0,1,.4-.7l3.37-1.94-1.29-.61c-.17-.08-.17-.38,0-.66A.83.83,0,0,1,118,188.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,184.17a1.79,1.79,0,0,1,1.39-.25l.31-.41a.86.86,0,0,1,.22-.21.39.39,0,0,1,.22-.05c.14,0,.21.17.19.37l-.17,1.27a.91.91,0,0,1-.18.42,1.42,1.42,0,0,1-.22.21l-.11,0-1,.28a.24.24,0,0,1-.31-.21.77.77,0,0,1,.18-.57l.1-.14a1.28,1.28,0,0,0-.63.2,3.27,3.27,0,0,0-1.47,2.55c0,.94.67,1.31,1.48.85a3.26,3.26,0,0,0,1.3-1.63.83.83,0,0,1,.36-.45.35.35,0,0,1,.19-.06c.2,0,.28.26.17.55a5,5,0,0,1-2,2.53c-1.26.73-2.3.14-2.3-1.32A5,5,0,0,1,124.92,184.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.73,192.37a.26.26,0,0,1,.3,0c.15.1.14.41,0,.68l-1.29,2.09,3.37-1.94c.23-.13.41,0,.41.23a.93.93,0,0,1-.41.72l-3.36,1.94,1.29.61c.16.08.18.37,0,.65a.85.85,0,0,1-.3.32.33.33,0,0,1-.28,0l-2.06-1-.09-.08v0l0-.16,0-.21v0l.08-.17,2-3.36A.89.89,0,0,1,110.73,192.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118,188.17a.31.31,0,0,1,.29,0l2.06,1,.08.09h0l0,.17,0,.21,0,0-.07.16-2.06,3.38a.83.83,0,0,1-.28.28.3.3,0,0,1-.3,0c-.15-.1-.14-.4,0-.68L119,190.7l-3.36,1.94c-.23.13-.41,0-.41-.24a.91.91,0,0,1,.4-.7l3.37-1.94-1.29-.61c-.17-.08-.17-.38,0-.66A.83.83,0,0,1,118,188.17Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.92,184.17a1.79,1.79,0,0,1,1.39-.25l.31-.41a.86.86,0,0,1,.22-.21.39.39,0,0,1,.22-.05c.14,0,.21.17.19.37l-.17,1.27a.91.91,0,0,1-.18.42,1.42,1.42,0,0,1-.22.21l-.11,0-1,.28a.24.24,0,0,1-.31-.21.77.77,0,0,1,.18-.57l.1-.14a1.28,1.28,0,0,0-.63.2,3.27,3.27,0,0,0-1.47,2.55c0,.94.67,1.31,1.48.85a3.26,3.26,0,0,0,1.3-1.63.83.83,0,0,1,.36-.45.35.35,0,0,1,.19-.06c.2,0,.28.26.17.55a5,5,0,0,1-2,2.53c-1.26.73-2.3.14-2.3-1.32A5,5,0,0,1,124.92,184.17Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "165.96 223.49 165.97 226.81 120.39 253.13 120.38 249.81 165.96 223.49",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.02 185.1 222.03 188.42 120.37 247.11 120.36 243.8 222.02 185.1",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222 179.09 222.01 182.4 120.35 241.09 120.34 237.78 222 179.09",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.98 173.07 221.99 176.39 120.33 235.08 120.33 231.76 221.98 173.07",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.31 168.34 191.32 172.06 185.21 175.58 185.22 177.29 190.58 174.2 190.59 177.73 185.23 180.82 185.24 182.74 191.57 179.09 191.58 182.79 181.04 188.88 181 174.3 191.31 168.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.89 174.94 179.9 178.75 176.18 180.9 176.21 191.66 171.94 194.13 171.91 183.37 168.19 185.51 168.18 181.7 179.89 174.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,196.68l2.67,3-4.56,2.64-2.17-2.42-1.16.67v3.66l-4.28,2.47,0-14.57,6.11-3.53c3.54-2,5.78-1.21,5.79,2.16A9.17,9.17,0,0,1,159.72,196.68Zm-3.67-.76a3.07,3.07,0,0,0,1.73-2.71c0-1.06-.56-1.39-1.74-.71l-1.56.9v3.42l1.56-.9",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,193.22l0,8a11.86,11.86,0,0,1-6.16,10.46c-3.89,2.25-6.19,1.05-6.2-3.33l0-8,4.27-2.46,0,7.87c0,2.23.76,2.63,2,1.94s1.93-1.95,1.93-4.18l0-7.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,205c4.13-2.38,7.16-.92,7.17,3.49s-3,9.38-7.13,11.76-7.17.93-7.19-3.49S123.12,207.38,127.26,205Zm0,11.27a6.25,6.25,0,0,0,2.83-5.29c0-2.27-1.28-2.91-2.85-2a6.22,6.22,0,0,0-2.84,5.29c0,2.28,1.27,2.91,2.86,2",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,162.42l5.59,11.38-4.42,2.55-.86-2-4.83,2.79-.84,3-4.35,2.51,5.51-17.78Zm-3.35,10.45,2.47-1.42-1.24-3-1.23,4.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223 150.05 223.08 164.61 219.18 166.86 219.12 160.23 216.39 167.16 214.5 168.25 211.73 164.73 211.75 171.15 207.85 173.4 207.81 158.82 211.32 156.79 215.48 162.18 219.49 152.08 223 150.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.65 190.33 251.87 268.81 176.09 312.56 175.87 234.08 251.65 190.33",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.31 83.6 337.44 127.82 234.98 186.97 234.85 142.75 337.31 83.6",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 238.35 168.7 316.83 120.65 344.57 120.42 266.1 168.48 238.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.67 141.24 336.89 219.72 259.27 264.54 259.05 186.06 336.67 141.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.48 238.35 168.7 316.83 120.65 344.57 120.42 266.1 168.48 238.35",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.67 141.24 336.89 219.72 259.27 264.54 259.05 186.06 336.67 141.24",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.68 129.23 271.69 134.47 242.67 151.27 242.65 146.03 271.68 129.23",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.89 133.63 278.9 136.82 242.69 157.66 242.68 154.47 278.89 133.63",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "271.68 129.23 271.69 134.47 242.67 151.27 242.65 146.03 271.68 129.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.89 133.63 278.9 136.82 242.69 157.66 242.68 154.47 278.89 133.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 156.2 272.67 159.41 242.74 176.87 242.73 173.67 272.66 156.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.93 146.43 278.94 149.63 242.72 170.47 242.71 167.27 278.93 146.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.63 151.09 259.64 154.29 242.7 164.07 242.69 160.87 259.63 151.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "144.53 259.76 144.55 264.55 126.03 275.24 126.02 270.45 144.53 259.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.97 256.79 162.98 259.04 126.05 280.37 126.04 278.11 162.97 256.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.99 261.3 162.99 263.55 126.06 284.88 126.06 282.62 162.99 261.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.28 278.28 152.3 283.07 126.1 298.2 126.09 293.41 152.28 278.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.53 276.47 144.54 278.72 126.07 289.38 126.07 287.13 144.53 276.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.17 327.29 136.17 329.54 126.2 335.3 126.2 333.05 136.17 327.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "144.53 259.76 144.55 264.55 126.03 275.24 126.02 270.45 144.53 259.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.97 256.79 162.98 259.04 126.05 280.37 126.04 278.11 162.97 256.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.99 261.3 162.99 263.55 126.06 284.88 126.06 282.62 162.99 261.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.28 278.28 152.3 283.07 126.1 298.2 126.09 293.41 152.28 278.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.53 276.47 144.54 278.72 126.07 289.38 126.07 287.13 144.53 276.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.17 327.29 136.17 329.54 126.2 335.3 126.2 333.05 136.17 327.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.12 307.22 163.12 309.47 126.19 330.79 126.19 328.54 163.12 307.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.1 302.71 163.11 304.96 126.18 326.29 126.17 324.03 163.1 302.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.2 307.11 142.21 311.89 126.16 321.15 126.15 316.37 142.2 307.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.5 292.56 156.5 294.81 126.14 312.34 126.13 310.08 156.5 292.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.05 284.25 163.06 286.51 126.13 307.83 126.12 305.58 163.05 284.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.04 279.75 163.05 282.01 126.11 303.33 126.11 301.07 163.04 279.75",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "224.42 229.93 209.37 258.52 205.11 266.62 208.04 257.5 199.75 251.06 190.5 269.42 190.53 280.63 239.03 252.63 239 241.41 224.42 229.93",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,245.09a9.12,9.12,0,0,0,4.12-7.14c0-2.62-1.87-3.68-4.15-2.36a9.06,9.06,0,0,0-4.12,7.13C204.38,245.35,206.23,246.4,208.52,245.09Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.42 229.93 209.37 258.52 205.11 266.62 208.04 257.5 199.75 251.06 190.5 269.42 190.53 280.63 239.03 252.63 239 241.41 224.42 229.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,245.09a9.12,9.12,0,0,0,4.12-7.14c0-2.62-1.87-3.68-4.15-2.36a9.06,9.06,0,0,0-4.12,7.13C204.38,245.35,206.23,246.4,208.52,245.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "310.25 181.31 295.2 209.9 290.94 218 293.87 208.88 285.57 202.44 276.33 220.8 276.36 232.01 324.86 204.01 324.83 192.79 310.25 181.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,196.47a9.07,9.07,0,0,0,4.12-7.14c0-2.62-1.86-3.68-4.14-2.36a9,9,0,0,0-4.12,7.13C290.2,196.73,292.06,197.78,294.34,196.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "310.25 181.31 295.2 209.9 290.94 218 293.87 208.88 285.57 202.44 276.33 220.8 276.36 232.01 324.86 204.01 324.83 192.79 310.25 181.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,196.47a9.07,9.07,0,0,0,4.12-7.14c0-2.62-1.86-3.68-4.14-2.36a9,9,0,0,0-4.12,7.13C290.2,196.73,292.06,197.78,294.34,196.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 156.2 272.67 159.41 242.74 176.87 242.73 173.67 272.66 156.2",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.93 146.43 278.94 149.63 242.72 170.47 242.71 167.27 278.93 146.43",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.63 151.09 259.64 154.29 242.7 164.07 242.69 160.87 259.63 151.09",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.12 307.22 163.12 309.47 126.19 330.79 126.19 328.54 163.12 307.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.1 302.71 163.11 304.96 126.18 326.29 126.17 324.03 163.1 302.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.2 307.11 142.21 311.89 126.16 321.15 126.15 316.37 142.2 307.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.5 292.56 156.5 294.81 126.14 312.34 126.13 310.08 156.5 292.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.05 284.25 163.06 286.51 126.13 307.83 126.12 305.58 163.05 284.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.04 279.75 163.05 282.01 126.11 303.33 126.11 301.07 163.04 279.75",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-74"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.14 123.65 328.34 125.26 330.02 151.55 332.69 167.24 341.88 168.31 338.12 151.55 333.87 123.8 331.14 123.65",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,165.32c6.34-2.37,10.48,1,10.48,1l1,26.89-11.31-6.47Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,165.32c6.34-2.37,10.48,1,10.48,1l1,26.89-11.31-6.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.85,165.32c6.34-2.37,10.48,1,10.48,1l1,26.89-11.31-6.47Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.94 97.23 294.99 114.52 295.06 137.41 325.01 120.12 324.94 97.23",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.94 97.23 325.01 120.12 327.78 121.73 327.71 95.63 324.94 97.23",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.06 137.41 295.07 140.62 327.78 121.73 325.01 120.12 295.06 137.41",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,89.85l-39.42,22.76.1,33.8,39.41-22.76Zm-36,50.77v-3.21L295,114.52l29.95-17.29,2.77-1.6.07,26.1Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.05 89.85 328.27 88.24 288.86 111 291.63 112.61 331.05 89.85",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.86 111 288.95 144.79 291.73 146.41 291.63 112.61 288.86 111",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.99 114.52 324.94 97.23 325.01 120.12 295.06 137.41 294.99 114.52",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "315.43 105.92 323.59 112.35 323.61 118.63 296.45 134.32 296.43 128.03 301.61 117.75 306.25 121.36 304.61 126.47 307 121.93 315.43 105.92",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5,109.09c1.28-.74,2.32-.15,2.33,1.32a5.1,5.1,0,0,1-2.31,4c-1.28.74-2.32.14-2.32-1.33A5.06,5.06,0,0,1,306.5,109.09Z",
    style: {
      fill: "#1EBC5A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.94 97.23 325.01 120.12 327.78 121.73 327.71 95.63 324.94 97.23",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.06 137.41 295.07 140.62 327.78 121.73 325.01 120.12 295.06 137.41",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.05,89.85l-39.42,22.76.1,33.8,39.41-22.76Zm-36,50.77v-3.21L295,114.52l29.95-17.29,2.77-1.6.07,26.1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.05 89.85 328.27 88.24 288.86 111 291.63 112.61 331.05 89.85",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.86 111 288.95 144.79 291.73 146.41 291.63 112.61 288.86 111",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.94,97.23,295,114.52l.07,22.89L325,120.12ZM306.5,109.09c1.28-.74,2.32-.15,2.33,1.32a5.1,5.1,0,0,1-2.31,4c-1.28.74-2.32.14-2.32-1.33A5.06,5.06,0,0,1,306.5,109.09Zm-10.05,25.23,0-6.28,5.18-10.29,4.64,3.61-1.64,5.11,2.39-4.54,8.43-16,8.16,6.43,0,6.28Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.43 105.92 307 121.93 304.61 126.47 306.25 121.36 301.61 117.75 296.43 128.03 296.45 134.32 323.61 118.63 323.59 112.35 315.43 105.92",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52,114.41a5.1,5.1,0,0,0,2.31-4c0-1.47-1.05-2.06-2.33-1.32a5.06,5.06,0,0,0-2.3,4C304.2,114.55,305.24,115.15,306.52,114.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.08,173.65,298.92,167l-5.74-27.09a3.75,3.75,0,0,1,.18-2.17l.7-1.73a7.21,7.21,0,0,0,.5-2.87l-.12-3.8a1.17,1.17,0,0,0-1.16-1.12h0a1.16,1.16,0,0,0-1.14.95l-.59,3.3-1.4,1.6-1.26-4.51V123.8l-2.84,4.12a5.21,5.21,0,0,0-.85,3.79l1.19,7.21,2.93,29.67a15.63,15.63,0,0,0,3.38,8.26l3.21,4Z",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.1,331.58a4.67,4.67,0,0,1-4.2,2.82,20.83,20.83,0,0,1-5.3-.68c-3.93-.71-7.73,0-11.66-.1a16.9,16.9,0,0,1-3.83-.41,6.34,6.34,0,0,1-3.28-1.94,4.26,4.26,0,0,1-.95-2,4,4,0,0,0,.95,3.2,6.34,6.34,0,0,0,3.28,1.94,16.9,16.9,0,0,0,3.83.41c3.93.1,7.73-.61,11.66.1a20.83,20.83,0,0,0,5.3.68,4.67,4.67,0,0,0,4.2-2.82,4.6,4.6,0,0,0,.13-1.81A3.85,3.85,0,0,1,320.1,331.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,328.32l-.72-3.58a5.22,5.22,0,0,0-.61-1.82,1.78,1.78,0,0,0-1.59-.91c-2.16-.29-5.19-1.07-7,.16a16.08,16.08,0,0,1-9.64,2.8,34.17,34.17,0,0,0-5.34-.21c-1.77.21-3.61,1.2-4.14,2.9a3.58,3.58,0,0,0-.09,1.56,4.26,4.26,0,0,0,.95,2,6.34,6.34,0,0,0,3.28,1.94,16.9,16.9,0,0,0,3.83.41c3.93.09,7.73-.61,11.66.1a20.83,20.83,0,0,0,5.3.68,4.67,4.67,0,0,0,4.2-2.82,3.85,3.85,0,0,0,.13-.66A8.18,8.18,0,0,0,320,328.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,318.42l-.16,4.66a1.85,1.85,0,0,0,1.72,1.91,29.31,29.31,0,0,0,4.69,0,2.68,2.68,0,0,0,2.41-2.5l.18-3.44Z",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,315.94a3.6,3.6,0,0,1-.62,1.93,3.55,3.55,0,0,1-2.2,1.24,5.56,5.56,0,0,1-5.46-2.25c-.59-.85-.92-1.85-1.48-2.72a12.35,12.35,0,0,0-3.06-3,12.93,12.93,0,0,1-3.08-3,4.36,4.36,0,0,1-.59-3.94,2.72,2.72,0,0,0-.29.5,4.48,4.48,0,0,0,.55,4.19,13.23,13.23,0,0,0,3.15,3.05,12.65,12.65,0,0,1,3.12,3.07c.57.89.91,1.92,1.51,2.8a5.65,5.65,0,0,0,5.57,2.32,3.6,3.6,0,0,0,2.24-1.28,4.35,4.35,0,0,0,.66-2.68C340,316.14,340,316,340,315.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,310.09c-1.42-2.48-4.34-4.29-6.6-6a8.48,8.48,0,0,0-4.37-2,4.1,4.1,0,0,0-4.06,2.08s0,.09-.05.13a4.36,4.36,0,0,0,.59,3.94,12.93,12.93,0,0,0,3.08,3,12.35,12.35,0,0,1,3.06,3c.56.87.89,1.87,1.48,2.72a5.56,5.56,0,0,0,5.46,2.25,3.55,3.55,0,0,0,2.2-1.24,3.6,3.6,0,0,0,.62-1.93c0-.22,0-.45,0-.67A11.1,11.1,0,0,0,338.59,310.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,307.94v4.24a7.1,7.1,0,0,0,6.59-.3l.4-3.81Z",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,231.08c1.27,3.82-.29,21.92-1,39.29,2.75,6.57,2,25.21.42,38.44,0,0-2.75,1.7-7.73,0L326,272.28l-.87-20.65s-1.57,18.32-3.37,30.07c1.69,9,1.27,10.7-2.91,38.39a10.45,10.45,0,0,1-9.37,0c-2.37-38.9-1.5-74.35-1.05-87.1Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,231.08c1.27,3.82-.29,21.92-1,39.29,2.75,6.57,2,25.21.42,38.44,0,0-2.75,1.7-7.73,0L326,272.28l-.87-20.65s-1.57,18.32-3.37,30.07c1.69,9,1.27,10.7-2.91,38.39a10.45,10.45,0,0,1-9.37,0c-2.37-38.9-1.5-74.35-1.05-87.1Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,231.08c1.27,3.82-.29,21.92-1,39.29,2.75,6.57,2,25.21.42,38.44,0,0-2.75,1.7-7.73,0L326,272.28l-.87-20.65s-1.57,18.32-3.37,30.07c1.69,9,1.27,10.7-2.91,38.39a10.45,10.45,0,0,1-9.37,0c-2.37-38.9-1.5-74.35-1.05-87.1Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.62,264.2l-.71-16.84c4.35,0,8.39-3.25,11.46-6.34a19.46,19.46,0,0,1-8.67,7.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.72,234c19.42,8.14,32,.79,33.72-3-.9-13.42,2.28-29.13,2-35.8S342.41,181,332.06,182.5l-11,1.07-5.58,1.36-6.69,13.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.06,177.23a3,3,0,0,0,2.15-.73,2.12,2.12,0,0,0,.51-1.85,2,2,0,0,0,1.48-1.2,2.31,2.31,0,0,0-.34-2,3.4,3.4,0,0,0,2.19-1.78,3.54,3.54,0,0,0,.09-2.9,3.13,3.13,0,0,0,2.2-2.13,3.39,3.39,0,0,0-.62-3.14,4.23,4.23,0,0,0,.49-4.21,4.47,4.47,0,0,0-3.62-2.45,4.36,4.36,0,0,0-1.42-3.9,4.22,4.22,0,0,0-4-.78,3.85,3.85,0,0,0-6.4-1.1,2.94,2.94,0,0,0-2.59-1,3,3,0,0,0-2.35,1.54,3.93,3.93,0,0,0-5.55,3.77,2.32,2.32,0,0,0-1.67,2.29,2.48,2.48,0,0,0,1.92,2.21A54.8,54.8,0,0,0,319.69,173c1.09,2.12,2.43,4.27,4.54,5.37C326.52,179.58,330.11,178.9,332.06,177.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.75 164.8 311.47 168.76 313.96 169.69 313.75 164.8",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.53,157.91a36.82,36.82,0,0,0-.65,16.83,5.72,5.72,0,0,0,1,2.66,4.22,4.22,0,0,0,2.9,1.33,12.25,12.25,0,0,0,3.24-.31v5.15c3.91.92,7.94,1.29,11-1.07v-5.27a14,14,0,0,1-6.83.42c-2.7-1.46-3.24-6.39-2.86-7.69a2,2,0,0,0,2.11.74,2.87,2.87,0,0,0,1.76-1.39,6,6,0,0,0,.65-2.2,4,4,0,0,0-.4-2.72,2.86,2.86,0,0,0-3.06-1,4.44,4.44,0,0,0-2.58,2.16,7.94,7.94,0,0,0-.45,1,.61.61,0,0,1-1.18-.15A8.11,8.11,0,0,1,320,162a3,3,0,0,1-2.21-1.35,2.82,2.82,0,0,1-.42-2.48A8.38,8.38,0,0,1,314.53,157.91Z",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,184.93l-11.87-13.57c-6.82,1.67-10.67,8.75-10.67,8.75l15.85,18.72C320.41,203.4,315.48,184.93,315.48,184.93Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,124.22l-.87-3.39-.91-4.09a1,1,0,0,1,.69-1.22h0a1,1,0,0,1,1.32.66l.76,2.22v-6.27l2.62,4.68a4.13,4.13,0,0,1,.5,2.31l-.39,4.68Z",
    style: {
      fill: "#ffcac9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,184.93l-11.87-13.57c-6.82,1.67-10.67,8.75-10.67,8.75l15.85,18.72C320.41,203.4,315.48,184.93,315.48,184.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,184.93l-11.87-13.57c-6.82,1.67-10.67,8.75-10.67,8.75l15.85,18.72C320.41,203.4,315.48,184.93,315.48,184.93Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.18,257.4a110.07,110.07,0,0,0-4.25-12.06h0c-5.2-13.92-8.63-17.57-14.78-16.43l4.24,20,5.35,10.32-4.86,8.13,5.37,8.49,8.11-12.58A7.07,7.07,0,0,0,408.18,257.4Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.67,374.68a5.36,5.36,0,0,1-3.85,2.31,17.69,17.69,0,0,1-5.27-.33,35.11,35.11,0,0,0-7.87-.2,42.31,42.31,0,0,1-4.89.35,7.76,7.76,0,0,1-4.61-1.46,4.66,4.66,0,0,1-1.72-2.94,4.41,4.41,0,0,0,1.72,4,7.76,7.76,0,0,0,4.61,1.46,40.2,40.2,0,0,0,4.89-.35,35.11,35.11,0,0,1,7.87.2c1.75.25,3.65.75,5.4.46a5.34,5.34,0,0,0,3.84-2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.57,371.57c1.46,0,.92-2.18,2.32-3.63-.57,0-1.14,0-1.71,0C359.93,369.79,359.57,371.57,360.57,371.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,371.45c1.47,0,1.09-2.59,2.54-4.1-.33.11-.67.21-1,.29s-.58.11-.87.16C363,369.63,362.61,371.45,363.62,371.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,366.49a2,2,0,0,0-.77-1.2l-7.93-.2a6.73,6.73,0,0,1-3.29,2.26c-1.45,1.51-1.07,4.1-2.54,4.1-1,0-.64-1.82.66-3.65-.46.07-.92.11-1.39.14-1.4,1.45-.86,3.63-2.32,3.63-1,0-.64-1.78.61-3.59h-1.11c-.34,0-.67,0-1-.06-2.92,2.31-3.17,4.81-2.79,8.74a11,11,0,0,0,1.52.16,42.31,42.31,0,0,0,4.89-.35,35.11,35.11,0,0,1,7.87.2,17.69,17.69,0,0,0,5.27.33,5.36,5.36,0,0,0,3.85-2.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06,367.91a12.59,12.59,0,0,0-4,0,4.71,4.71,0,0,0-3.57,3.11,3.43,3.43,0,0,0-.06,1.39,4.66,4.66,0,0,0,1.72,2.94,6.91,6.91,0,0,0,3.09,1.3C355.89,372.72,356.14,370.22,359.06,367.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,362.83v3.82a1.58,1.58,0,0,0,1.57,1.58h4a2.58,2.58,0,0,0,2.58-2.5l.1-2.9Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.67,361.13a3,3,0,0,1-2.41,1.69,5.11,5.11,0,0,1-3.05-.75c-1.37-.88-1.91-2.25-2.85-3.49a20.76,20.76,0,0,0-3.32-3.24,11,11,0,0,1-3.17-3.68,4.74,4.74,0,0,1-.37-1.35,4.7,4.7,0,0,0,.37,2.59,11,11,0,0,0,3.17,3.68,20.76,20.76,0,0,1,3.32,3.24c.94,1.24,1.48,2.61,2.85,3.49a5.11,5.11,0,0,0,3.05.75,3,3,0,0,0,2.41-1.69,6.67,6.67,0,0,0,.14-2.13A2.77,2.77,0,0,1,395.67,361.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,352.74a1,1,0,0,0-.19.65.66.66,0,0,0,.43.5,1,1,0,0,0,.89-.23,4.87,4.87,0,0,0,.62-.74,4.73,4.73,0,0,1,2-1.49,5.12,5.12,0,0,1,1.22-.27l-1-.9a5.17,5.17,0,0,0-1.81.44A5.07,5.07,0,0,0,386.65,352.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.86,349.59a5,5,0,0,0-2.21,2,1,1,0,0,0-.19.65.63.63,0,0,0,.43.49.93.93,0,0,0,.89-.23,4.35,4.35,0,0,0,.62-.73,4.65,4.65,0,0,1,2-1.49,4.74,4.74,0,0,1,2-.27l-1-.89A5,5,0,0,0,386.86,349.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.84,348.59a10.41,10.41,0,0,0-3.11-2.08,4.16,4.16,0,0,0-4.29.59,3.71,3.71,0,0,0-.94,3.21,4.74,4.74,0,0,0,.37,1.35,7.19,7.19,0,0,0,1,1.56C382.24,349.8,385.2,348.21,388.84,348.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,357.78a7.07,7.07,0,0,0-.77-3.34l-1.93-2-1.38-1.26a5.12,5.12,0,0,0-1.22.27,4.73,4.73,0,0,0-2,1.49,4.87,4.87,0,0,1-.62.74,1,1,0,0,1-.89.23.66.66,0,0,1-.43-.5,1,1,0,0,1,.19-.65,5.07,5.07,0,0,1,2.21-2,5.17,5.17,0,0,1,1.81-.44l-.22-.21a4.74,4.74,0,0,0-2,.27,4.65,4.65,0,0,0-2,1.49,4.35,4.35,0,0,1-.62.73.93.93,0,0,1-.89.23.63.63,0,0,1-.43-.49,1,1,0,0,1,.19-.65,4.93,4.93,0,0,1,4.82-2.47l0,0-.59-.54c-3.64-.38-6.6,1.21-7,4.63a16.88,16.88,0,0,0,2.19,2.12,20.76,20.76,0,0,1,3.32,3.24c.94,1.24,1.48,2.61,2.85,3.49a5.11,5.11,0,0,0,3.05.75,3,3,0,0,0,2.41-1.69,2.77,2.77,0,0,0,.14-.89A23,23,0,0,0,395.74,357.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.78,351.74l.23,4.1c2.59,1.49,5.31.68,6.22-.26l.17-3.84Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88,263.06a3.67,3.67,0,0,1-.39-1.41l-.22-3.52-25.09,1.61c-.33,1.76-.67,3.92-1,6.36A37.35,37.35,0,0,0,393.88,263.06Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,230.55l-6.72,1.32c-1.48,2.71-3,5.26-4.48,8-1.11,2-2.26,4.22-2.18,6.55a6.67,6.67,0,0,0,4,5.78l-.77,9.17c10.54,3.22,23.43.39,26.26-2.05.83-3.84,1.57-7.93,2.4-11.77A40.38,40.38,0,0,0,397.3,240a13.31,13.31,0,0,0-1.78-7.35l0-.06a8.21,8.21,0,0,0-8.24-3.54Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,230.55l-6.72,1.32c-1.48,2.71-3,5.26-4.48,8-1.11,2-2.26,4.22-2.18,6.55a6.67,6.67,0,0,0,4,5.78l-.77,9.17c10.54,3.22,23.43.39,26.26-2.05.83-3.84,1.57-7.93,2.4-11.77A40.38,40.38,0,0,0,397.3,240a13.31,13.31,0,0,0-1.78-7.35l0-.06a8.21,8.21,0,0,0-8.24-3.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,230.55l-6.72,1.32c-1.48,2.71-3,5.26-4.48,8-1.11,2-2.26,4.22-2.18,6.55a6.67,6.67,0,0,0,4,5.78l-.77,9.17c10.54,3.22,23.43.39,26.26-2.05.83-3.84,1.57-7.93,2.4-11.77A40.38,40.38,0,0,0,397.3,240a13.31,13.31,0,0,0-1.78-7.35l0-.06a8.21,8.21,0,0,0-8.24-3.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.27,263.7a3.77,3.77,0,0,1-.39-.64,37.35,37.35,0,0,1-26.69,3c-1.9,14.07-3.52,37.91-2.52,53.63.83,18.3,4.19,44.22,4.19,44.22,4.4,1.32,7.69.51,8.94-.44,1.46-18.15,4.68-30.6,2.19-42.61,1.66-8.39,2.74-18.94,2.74-18.94L384,320.51l4.29,32.61a7.72,7.72,0,0,0,7.71-.39c3.13-18.65,4.3-31.28,1.57-40.54C401.74,281.59,402,273.77,394.27,263.7Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.27,263.7a3.77,3.77,0,0,1-.39-.64,37.35,37.35,0,0,1-26.69,3c-1.9,14.07-3.52,37.91-2.52,53.63.83,18.3,4.19,44.22,4.19,44.22,4.4,1.32,7.69.51,8.94-.44,1.46-18.15,4.68-30.6,2.19-42.61,1.66-8.39,2.74-18.94,2.74-18.94L384,320.51l4.29,32.61a7.72,7.72,0,0,0,7.71-.39c3.13-18.65,4.3-31.28,1.57-40.54C401.74,281.59,402,273.77,394.27,263.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,298.3l2.31-9.66a13.54,13.54,0,0,0,9.08-5.88,18.47,18.47,0,0,1-11.13,3.92L382.73,302l.44,6.53.18-2.37A50.28,50.28,0,0,1,384.57,298.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.87,231.75c-4.16.19-10.4.88-16.52.76a55.51,55.51,0,0,1-10.4-1.14s-8.2-9.46-10.6-13.66c.57-2.25,1.15-4.46,1.72-6.7a3.8,3.8,0,0,0-.14-2.31,15.93,15.93,0,0,0-1.49-2.91c-.8-1.19-1.34-2.44-2.72-2.83-2.11-.58.22,2.25.91,3.39a15.13,15.13,0,0,0-3.3,1.63,1.33,1.33,0,0,0-.28,2l.34.39a8.81,8.81,0,0,0-.14,8l7.2,18.62a7,7,0,0,0,5.3,4.35l11.56,2,14.42,2.52a6.19,6.19,0,0,0,7-4.57c.45-1.82.93-3.35,1.21-5.13A3.87,3.87,0,0,0,369.87,231.75Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.39 214.46 366.32 218.06 368.59 218.9 368.39 214.46",
    style: {
      fill: "#e39b81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,212.85c.33-3.16,1.25-6.14,3.31-7.65a17.08,17.08,0,0,0,2.37,11.31,5,5,0,0,1,1.53-2.71,2.63,2.63,0,0,1,4.43,1,3.84,3.84,0,0,1-4.8,5.07,7.39,7.39,0,0,0,5.67,5.74,9.53,9.53,0,0,0,5.5-.53l.85,4.26c-3.47,3.7-9.39,1.22-9.39,1.22l-.78-4.19c-6.82.4-7.46.29-8.21-3.47A36.77,36.77,0,0,1,368.16,212.85Z",
    style: {
      fill: "#ffbea7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.54,199.62c-3.23-1.16-7.06.59-8.82,3.53a11.17,11.17,0,0,0-.35,9.91,11.49,11.49,0,0,1,3.1-7.86c-.64,4.84-.08,8.36,2.37,11.31a3.56,3.56,0,0,1,.83,2.26c0,.81-.19,1.62-.14,2.43.12,1.7,1.27,3.13,2.35,4.45s2.2,2.79,2.24,4.5c.05,2.83-.81,5.82-1,8.64a13.17,13.17,0,0,0,1.92,8.11,10.72,10.72,0,0,0,10.64,4.26,12.43,12.43,0,0,0,8.92-7.47,14.86,14.86,0,0,0-.44-11.78c-1.43-3.07-3.8-5.63-5.18-8.72-1.53-3.43-1.76-7.26-2.2-11s-1.21-7.59-3.56-10.52A9,9,0,0,0,377.54,199.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.93,329.32l1.88,3.95-4.49,4.94.33,11.78,14.46-12.55a3.92,3.92,0,0,0,1-4.66l-4.41-9.17Z",
    style: {
      fill: "#8c5757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39,336.8a9.13,9.13,0,0,1-2.58-3.53l-1.12,1.23A5.73,5.73,0,0,0,327.39,336.8Z",
    style: {
      fill: "#6e3636"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,330.27c5.75-.5,9.66-6.45,9.66-6.45-5.14-10.52-9.62-22.22-18.59-19.43Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,330.27c5.75-.5,9.66-6.45,9.66-6.45-5.14-10.52-9.62-22.22-18.59-19.43Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.16,454c-.54,1.71-2.41,2.68-4.2,2.83a20.85,20.85,0,0,1-5.31-.68c-3.95-.72-7.75,0-11.69-.1a16.5,16.5,0,0,1-3.84-.42,6.37,6.37,0,0,1-3.29-1.94,4.29,4.29,0,0,1-.95-2.06,4.09,4.09,0,0,0,.95,3.22,6.28,6.28,0,0,0,3.29,1.93,16.5,16.5,0,0,0,3.84.42c3.94.09,7.74-.61,11.69.1A20.85,20.85,0,0,0,296,458a4.65,4.65,0,0,0,4.2-2.83,4.41,4.41,0,0,0,.14-1.81A3.88,3.88,0,0,1,300.16,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.06,450.71c-.24-1.2-.49-2.39-.73-3.59a5.22,5.22,0,0,0-.61-1.82,1.78,1.78,0,0,0-1.59-.91c-2.16-.29-5.2-1.07-7,.16a16.06,16.06,0,0,1-9.66,2.81,34.31,34.31,0,0,0-5.35-.22c-1.77.22-3.62,1.21-4.14,2.92a3.38,3.38,0,0,0-.1,1.55,4.29,4.29,0,0,0,.95,2.06,6.37,6.37,0,0,0,3.29,1.94A16.5,16.5,0,0,0,279,456c3.94.09,7.74-.62,11.69.1a20.85,20.85,0,0,0,5.31.68c1.79-.15,3.66-1.12,4.2-2.83a3.88,3.88,0,0,0,.14-.66A8.57,8.57,0,0,0,300.06,450.71Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.61,440.8l-.16,4.67a1.86,1.86,0,0,0,1.72,1.91,29.55,29.55,0,0,0,4.71-.05,2.66,2.66,0,0,0,2.41-2.5l.18-3.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,438.31a3.61,3.61,0,0,1-.63,1.93,3.5,3.5,0,0,1-2.2,1.24,5.54,5.54,0,0,1-5.47-2.25c-.59-.85-.93-1.85-1.48-2.72a12.26,12.26,0,0,0-3.07-3,13,13,0,0,1-3.09-3,4.38,4.38,0,0,1-.59-3.95,3.1,3.1,0,0,0-.29.5,4.49,4.49,0,0,0,.55,4.21,13.47,13.47,0,0,0,3.16,3.05,12.72,12.72,0,0,1,3.13,3.08c.57.89.91,1.92,1.51,2.8a5.64,5.64,0,0,0,5.58,2.32,3.56,3.56,0,0,0,2.25-1.28,4.35,4.35,0,0,0,.65-2.68C320.12,438.51,320.11,438.41,320.11,438.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,432.45c-1.42-2.49-4.35-4.3-6.61-6.06a8.41,8.41,0,0,0-4.38-2,4.09,4.09,0,0,0-4.07,2.08s0,.09-.05.13a4.38,4.38,0,0,0,.59,3.95,13,13,0,0,0,3.09,3,12.26,12.26,0,0,1,3.07,3c.55.87.89,1.87,1.48,2.72a5.54,5.54,0,0,0,5.47,2.25,3.5,3.5,0,0,0,2.2-1.24,3.61,3.61,0,0,0,.63-1.93c0-.22,0-.45,0-.67A10.87,10.87,0,0,0,318.69,432.45Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.53,430.29v4.25a7.14,7.14,0,0,0,6.61-.3l.4-3.82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65,353.27c1.27,3.82.88,23.85.14,41.25,1.21,8.47,1.17,26.83-.42,40.09a13.56,13.56,0,0,1-10.59.21L306,394.55l-.87-20.69s-1.57,18.36-3.37,30.14c.65,8.65-.78,25.18-2.05,42.81,0,0-6.81,4-13.57-.38-2.38-39,1.47-78.46,2.26-91.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.69,386.46,305,369.58c4.37,0,8.41-3.26,11.49-6.35a19.55,19.55,0,0,1-8.69,7.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.76,323.16v33.06c19.46,8.15,32.07.78,33.79-3.05-.9-13.45,2.28-29.19,2-35.88s-1.07-14.22-11.44-12.71l-11,1.08L295.54,307Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.76,323.16v33.06c19.46,8.15,32.07.78,33.79-3.05-.9-13.45,2.28-29.19,2-35.88s-1.07-14.22-11.44-12.71l-11,1.08L295.54,307Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,321.37l-3.71,3.86-8.91-11.8a34.2,34.2,0,0,0,2.18-9.78,1.06,1.06,0,0,0-1.05-1.11h0a1,1,0,0,0-.95.61l-1.65,3.46h0a1.63,1.63,0,0,1-1-1l-.32-.92a5.64,5.64,0,0,1-.33-1.91V300.5a1.84,1.84,0,0,0-2.72-1.6,8.89,8.89,0,0,0-2.69,2.23,4.83,4.83,0,0,0-1.1,3.09v3.08a6.79,6.79,0,0,0,.41,2.32l1.61,4.43a6.47,6.47,0,0,0,.55,1.16l11.49,19.25a5.47,5.47,0,0,0,8.33,1.29l7.32-6.5Z",
    style: {
      fill: "#8c5757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,330a11.11,11.11,0,0,1,2.28-4.75l-1-1.35C271.92,325.3,270.83,328.08,271.44,330Z",
    style: {
      fill: "#6e3636"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,330a11.11,11.11,0,0,1,2.28-4.75l-1-1.35C271.92,325.3,270.83,328.08,271.44,330Z",
    style: {
      fill: "#6e3636"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,321.39,287,311.11a14.67,14.67,0,0,1,8.59-4.12l.18,0c4.43,9.69-1.42,14.42-1.42,14.42l-9.72,8.93A17.56,17.56,0,0,1,276.51,321.39Z",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,321.39,287,311.11a14.67,14.67,0,0,1,8.59-4.12l.18,0c4.43,9.69-1.42,14.42-1.42,14.42l-9.72,8.93A17.56,17.56,0,0,1,276.51,321.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.84,283a1.57,1.57,0,0,1-.23-1.73A2,2,0,0,1,294,281a1.51,1.51,0,0,1-.72-1.4,1.28,1.28,0,0,1,1.06-1.12,2,2,0,0,1-1.25-.86,2,2,0,0,1-.4-1.46,2.68,2.68,0,0,1,1.84-2.05,6.36,6.36,0,0,1,2.88-.15,2.32,2.32,0,0,1,1.21-2.73,2.82,2.82,0,0,1,2.64.44,8.28,8.28,0,0,1,1.86,2.05,8.23,8.23,0,0,1,11.69,4.56,5.64,5.64,0,0,1,3.65,3.81,8.91,8.91,0,0,1-.31,5.35,23.89,23.89,0,0,1-2.5,4.81l-1.38,2.19c-.58.91-2.05,3.18-2.63,4.1a8.59,8.59,0,0,1-8.16-.51,13.84,13.84,0,0,1-5.23-6.49A44.55,44.55,0,0,1,295.84,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.09,299.48a9,9,0,0,1-4.7-1.33,14,14,0,0,1-5.29-6.56,44.57,44.57,0,0,1-2.38-8.56,1.57,1.57,0,0,1-.32-1.61,2.19,2.19,0,0,1-1.5-.3,1.66,1.66,0,0,1-.78-1.53,1.41,1.41,0,0,1,.75-1.1,2.58,2.58,0,0,1-.92-.79,2.17,2.17,0,0,1-.42-1.56,2.79,2.79,0,0,1,1.93-2.15,6.4,6.4,0,0,1,2.74-.19,2.46,2.46,0,0,1,1.34-2.69,3,3,0,0,1,2.76.45,8.14,8.14,0,0,1,1.84,2,8.51,8.51,0,0,1,6.89-.4,8.72,8.72,0,0,1,4.85,5,5.72,5.72,0,0,1,3.68,3.87,9.12,9.12,0,0,1-.32,5.43,24.22,24.22,0,0,1-2.51,4.84c-.45.73-.92,1.46-1.38,2.19L313,296.59c-.5.79-1,1.57-1.29,2l0,0h0A8,8,0,0,1,308.09,299.48ZM295.86,281l-.13.29a1.41,1.41,0,0,0,.2,1.57l0,0v0a44.52,44.52,0,0,0,2.37,8.56,13.9,13.9,0,0,0,5.18,6.43,8.41,8.41,0,0,0,8,.52c.28-.46.78-1.22,1.27-2s1-1.62,1.34-2.08c.46-.73.92-1.45,1.38-2.19a23.75,23.75,0,0,0,2.49-4.79,8.9,8.9,0,0,0,.31-5.26,5.53,5.53,0,0,0-3.57-3.72l-.06,0,0-.06a8.4,8.4,0,0,0-4.73-4.92,8.26,8.26,0,0,0-6.78.43l-.1.05-.06-.09a8.09,8.09,0,0,0-1.84-2,2.73,2.73,0,0,0-2.51-.42,2.2,2.2,0,0,0-1.14,2.56l.07.2-.21,0a6.25,6.25,0,0,0-2.81.15,2.56,2.56,0,0,0-1.76,1.93,2.07,2.07,0,0,0,1.54,2.18l1,.15-1,.11a1.15,1.15,0,0,0-.95,1,1.37,1.37,0,0,0,.66,1.28,1.84,1.84,0,0,0,1.53.22Z",
    style: {
      fill: "#272525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,288.62l-1.74,3,1.72.63A34.37,34.37,0,0,1,294.58,288.62Z",
    style: {
      fill: "#6e3636"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.84,283a24.85,24.85,0,0,0-1.26,5.66,34.37,34.37,0,0,0,0,3.66,35.23,35.23,0,0,0,.6,5.12,5.46,5.46,0,0,0,1,2.57,4,4,0,0,0,2.78,1.28,12.23,12.23,0,0,0,3.13-.3v5c3.77.89,6.89,1.28,9.84-1l-.31-6.38a9.28,9.28,0,0,1-5.31-.84c-2.6-1.41-3.33-3.65-3-4.9a1.94,1.94,0,0,0,2,.71,2.7,2.7,0,0,0,1.69-1.34,5.55,5.55,0,0,0,.63-2.11,3.85,3.85,0,0,0-.38-2.62,2.74,2.74,0,0,0-2.95-1,4.2,4.2,0,0,0-2.48,2.07,6.8,6.8,0,0,0-.44,1,.59.59,0,0,1-1.14-.14,7.85,7.85,0,0,1,.75-4.16,3.26,3.26,0,0,1-1.39.33,1.77,1.77,0,0,1-1.34-.62,1.2,1.2,0,0,1-.05-1.41A2.33,2.33,0,0,1,295.84,283Z",
    style: {
      fill: "#8c5757"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.93,438a25,25,0,0,0,11.45,6.52c1.24.32,2.7.7,3.16,1.9a2.91,2.91,0,0,1-1.29,3.12,7.75,7.75,0,0,1-5.51,1.24,24.64,24.64,0,0,1-5.55-1.55,20.56,20.56,0,0,0-5.58-1.43,24.84,24.84,0,0,1-2.73-.16,3.28,3.28,0,0,1-2.28-1.34c0-5.55,1.44-7.54,1.44-7.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.06,435.55v3.76c-2.53,2.76-6.54.92-7-.55l-.13-3.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,422.07c4.49-4.06,7-3.9,8.07-3.09s3,3.42-2,7.81-4.61,7.1-8.08,7.1-2.81-3.47-2.81-3.47a15.25,15.25,0,0,1,.54-3.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.79,424.67v2.66c-2.11,1.81-5.66.78-5.85-.46l.16-2.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.39,350.85l2,46.18-5.28,38.52c-2.81,1.81-7.15,0-7.15,0-.58-11.85-3.18-28.66-1.12-37.65l-3.9-24.83L192.59,393c-.22,11.71-3.26,24.17-3.8,31.65a6.53,6.53,0,0,1-5.69-.43c-1.75-15.57-5.22-24-1.9-35.09-2.31-20.95-4.29-34-1.38-39.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.14,368.34l.75,4.73-.41,6.29L192,369.5a9,9,0,0,1-6.45-4.12A16.73,16.73,0,0,0,193.14,368.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,307.6l-13.62-1.82c-5.7-.55-8.15,5.7-8.07,11.48,0,3.41,1.82,12,2.91,20.94a34.53,34.53,0,0,0-2.44,9c-1.35,6.65,21.11,10.38,29.68,5.88a3.15,3.15,0,0,0,1.64-2.9c-.39-12.1-1.87-26.75-1.87-26.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,307.6l-13.62-1.82c-5.7-.55-8.15,5.7-8.07,11.48,0,3.41,1.82,12,2.91,20.94a34.53,34.53,0,0,0-2.44,9c-1.35,6.65,21.11,10.38,29.68,5.88a3.15,3.15,0,0,0,1.64-2.9c-.39-12.1-1.87-26.75-1.87-26.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,288.09a12.1,12.1,0,0,0,1.37-6.44,7,7,0,0,0-3.38-5.44,4.9,4.9,0,0,0-6,1.06A11.22,11.22,0,0,0,182.33,288c.15,2.31,1,4.59.74,6.9-.16,1.35-.69,2.72-.34,4a4.22,4.22,0,0,0,2.2,2.49c1,.53,3.38.39,4.49.62,3.41,3.1,7.69,1.94,10.41-.83S207,288.09,207,288.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,288.09a12.1,12.1,0,0,0,1.37-6.44,7,7,0,0,0-3.38-5.44,4.9,4.9,0,0,0-6,1.06A11.22,11.22,0,0,0,182.33,288c.15,2.31,1,4.59.74,6.9-.16,1.35-.69,2.72-.34,4a4.22,4.22,0,0,0,2.2,2.49c1,.53,3.38.39,4.49.62,3.41,3.1,7.69,1.94,10.41-.83S207,288.09,207,288.09Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,288.09a12.1,12.1,0,0,0,1.37-6.44,7,7,0,0,0-3.38-5.44,4.9,4.9,0,0,0-6,1.06A11.22,11.22,0,0,0,182.33,288c.15,2.31,1,4.59.74,6.9-.16,1.35-.69,2.72-.34,4a4.22,4.22,0,0,0,2.2,2.49c1,.53,3.38.39,4.49.62,3.41,3.1,7.69,1.94,10.41-.83S207,288.09,207,288.09Z",
    style: {
      fill: "#8c5757"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.68 291.17 209.81 294.87 207.47 295.73 207.68 291.17",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,289.52c-.34-3.25-1.29-6.31-3.41-7.86a17.58,17.58,0,0,1-2.43,11.62,5.13,5.13,0,0,0-1.58-2.79,2.92,2.92,0,0,0-3-.64A3,3,0,0,0,196,291.5a3.94,3.94,0,0,0,4.93,5.21,7.59,7.59,0,0,1-5.82,5.9,9.86,9.86,0,0,1-5.65-.54l-.88,4.38c3.56,3.79,9.65,1.24,9.65,1.24l.8-4.3c7,.41,7.66.29,8.43-3.56A38.23,38.23,0,0,0,207.92,289.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,284.81a12.26,12.26,0,0,0-5.57-6.66,11.73,11.73,0,0,0-4.5,9.87c.15,2.31,1,4.59.74,6.9-.16,1.35-.69,2.72-.34,4a4.22,4.22,0,0,0,2.2,2.49c1,.53,3.38.39,4.49.62l.45.37a33.9,33.9,0,0,0,2.77-7.12A18.09,18.09,0,0,0,192.4,284.81Z",
    style: {
      fill: "#6e3636"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,282.37a8.93,8.93,0,0,0-17-.21c-2.11,6.4,3.3,13.2,2.12,19.83-.43,2.39-1.69,4.57-2.13,6.95A10.32,10.32,0,0,0,182.32,321c-1.52-1.68-1.55-4.27-.68-6.36a28.66,28.66,0,0,1,3.75-5.64C190.76,301.63,193.11,291.11,190.46,282.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,282.37a8.93,8.93,0,0,0-17-.21c-2.11,6.4,3.3,13.2,2.12,19.83-.43,2.39-1.69,4.57-2.13,6.95A10.32,10.32,0,0,0,182.32,321c-1.52-1.68-1.55-4.27-.68-6.36a28.66,28.66,0,0,1,3.75-5.64C190.76,301.63,193.11,291.11,190.46,282.37Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,282.37a8.93,8.93,0,0,0-17-.21c-2.11,6.4,3.3,13.2,2.12,19.83-.43,2.39-1.69,4.57-2.13,6.95A10.32,10.32,0,0,0,182.32,321c-1.52-1.68-1.55-4.27-.68-6.36a28.66,28.66,0,0,1,3.75-5.64C190.76,301.63,193.11,291.11,190.46,282.37Z",
    style: {
      fill: "#8c5757"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.66 296.67 236.09 324.4 216.31 313.42 225.77 286 245.66 296.67",
    style: {
      fill: "#1EBC5A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.66 296.67 236.09 324.4 216.31 313.42 225.77 286 245.66 296.67",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.66 296.67 236.09 324.4 216.31 313.42 225.77 286 245.66 296.67",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.25 312.3 227.13 289.46 242.71 297.82 234.75 320.9 219.25 312.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.87 291.16 238.53 295.7 238.91 294.55 237.23 293.07 232.48 290.68 230.32 290.28 229.87 291.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.48 290.68 232.86 289.8 237.49 292.29 237.23 293.07 232.48 290.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.17 288.36 240.64 293.98 241.09 292.89 230.53 287.34 230.17 288.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,288.64c.91-2.88,6.39-.17,5.32,2.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,319.05l7.3,9.48,12.69-12.48a4.48,4.48,0,0,0,1.29-2.6c.6-4.74,1.92-8.12,3.6-7.52,1.06.37-.3,5-.3,5l1.58-.9,1.85-5.35h.83a2.12,2.12,0,0,1,2,1.42l.79,2.28a6.71,6.71,0,0,1-2.35,7.59L241.38,318a4.75,4.75,0,0,0-1.06,1.13,138.61,138.61,0,0,1-14.88,19,3.79,3.79,0,0,1-4.8.5c-7.77-5.14-14.19-13.82-14.19-13.82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,307.6l1.24.15A15.39,15.39,0,0,1,212,313.66l9.3,12.11a10.09,10.09,0,0,1-7.83,8.9l-10.22-10.8C197.92,318.05,200.42,307.6,200.42,307.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.42,307.6l1.24.15A15.39,15.39,0,0,1,212,313.66l9.3,12.11a10.09,10.09,0,0,1-7.83,8.9l-10.22-10.8C197.92,318.05,200.42,307.6,200.42,307.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsTeam);
export default __webpack_public_path__ + "static/media/about-us-team.202b70c6c496ac79e5f50fa05aa9892d.svg";
export { ForwardRef as ReactComponent };